import { render, staticRenderFns } from "./longAnswerCard.vue?vue&type=template&id=07cf3521&scoped=true"
import script from "./longAnswerCard.vue?vue&type=script&lang=js"
export * from "./longAnswerCard.vue?vue&type=script&lang=js"
import style0 from "./longAnswerCard.vue?vue&type=style&index=0&id=07cf3521&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cf3521",
  null
  
)

export default component.exports